import { Col, Row } from 'antd5';
import { useTheme } from 'styled-components';

import { type AttributeLayout, resolveAttributeLayout } from 'components/damages/attributeLayout';
import { Description, Label } from 'horizon/components/Damages/DamageStyles.style';

type AttributesProps = {
  attrs: { [key: string]: any };
  damageColumns: any[];
  layout?: AttributeLayout;
  critical?: boolean | null;
  highlightedKeys?: string[];
};

export const Attributes: React.FunctionComponent<AttributesProps> = ({
  attrs,
  damageColumns,
  layout,
  critical,
  highlightedKeys,
}) => {
  const theme = useTheme();
  const { columnCount: numberOfDisplayColumns, columns: chunkedDamageColumns } =
    resolveAttributeLayout(damageColumns, layout);

  const columnProps = {
    xs: 24,
    xxl: Math.round(24 / numberOfDisplayColumns),
  };

  return (
    <Row gutter={16}>
      {chunkedDamageColumns.map((columns, index) => (
        <Col key={index} {...columnProps}>
          {columns.map(column => {
            const key = column.key;
            const title = column.title;
            const value = column.render(attrs[key], { critical });
            const isHighlighted = highlightedKeys?.includes(key);
            return (
              <div key={key}>
                <Label style={isHighlighted ? { color: theme.red } : undefined}>{title}</Label>
                <Description style={isHighlighted ? { color: theme.red } : undefined}>
                  {value}
                </Description>
              </div>
            );
          })}
        </Col>
      ))}
    </Row>
  );
};
